import { useEffect, useState } from 'react';

import {useEditProfileDataContext} from '../../../../context/account/editProfile.provider';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { dataLayerPush } from '../../../../helpers/dataLayerPush';
import useForm from '../../../../helpers/useForm';
import ChangePasswordValidation from './ChangePassword.validations';

const useChangePassword = () => {
    const [open, setOpen] = useState(false);
    const [showPass, setShowPass] = useState(false);
    const { loading, submitErrors, submitSuccess, changePassword } =
      useEditProfileDataContext();
    const { onLogout, user } = useAuthDataContext();
  
    useEffect(() => {
      dataLayerPush('Cuenta_modificar_contraseña', user?.id);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
  
    const onSave = () => {
      onOpen();
    };
  
    const onSubmit = () => {
      changePassword(values);
      onClose();
    };
  
    useEffect(() => {
      if (submitSuccess.change_password) {
        onLogout();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [submitSuccess]);
  
    const { values, errors, handleChange, handleSubmit } = useForm(
      onSave,
      ChangePasswordValidation
    );
  
    const onClose = () => {
      setOpen(false);
    };
  
    const onOpen = () => {
      setOpen(true);
    };  

    return {
        loading,
        open,
        onClose,
        errors,
        onSubmit,
        submitErrors,
        handleChange,
        showPass,
        setShowPass,
        handleSubmit
    };
};

export default useChangePassword;